import { GetStaticProps } from "next";
import fs from "fs";
import Head from "next/head";
import path from "path";

import CapabilitiesPage from "../components/CapabilitiesPage";

import { CapabilitiesPageProps } from "../components/CapabilitiesPage/constants";
import { FlashPCBPage } from "../models/page";
import settings from "../constants/settings";
import { LeadTimeOptions } from "../reducers/uploadedBoard";
import { FlashPCBSettings } from "../utils/settings";

const Capabilities: FlashPCBPage<CapabilitiesPageProps> = (props) => {
  return (
    <>
      <Head>
        <title>Our Capabilities</title>
        <meta
          name="description"
          content="FlashPCB's manufacturing capabiltiies. Whether you want an instant quote or you desire more advanced features, we spell it all out for you here."
        />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <CapabilitiesPage {...props} />
    </>
  );
};

export const getStaticProps: GetStaticProps = async () => {
  const settingsResponse = await fetch(`${settings.api_url}/settings`);
  const flashPCBSettings = (await settingsResponse.json()) as FlashPCBSettings;

  const markdown = fs.readFileSync(
    path.resolve("./public/capabilities/capabilities.md"),
    "utf8",
  );

  const leadTimeOptionsResponse = await fetch(
    `${settings.api_url}/boards/lead-time-options`,
  );
  const { options: leadTimeOptions, dates_closed: datesClosed } =
    (await leadTimeOptionsResponse.json()) as LeadTimeOptions;

  return {
    props: { flashPCBSettings, leadTimeOptions, datesClosed, markdown },
    revalidate: 60,
  };
};

export default Capabilities;
